import { getDateLocale } from './dateLocale';

export const convertToReadableDate = (date: string): string => {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString(getDateLocale());
};
